import { HelperService } from '../utils/helper.service'
/**
 * To string transformer service
 */
export class TransformerService {
    constructor() {
        const { $translate, $formatDate, $formatDateTime, $config, $getColor } = useNuxtApp()
        this.$translate = $translate
        this.$formatDate = $formatDate
        this.$formatDateTime = $formatDateTime
        this.$config = $config
        this.$getColor = $getColor
    }

    isChips(key, value, template, translationKey): string {
        return value ? `<v-chip variant="${this.$config.public.chips_variant || 'tonal'}" size="small" color="${this.$getColor(`${translationKey}.${key}.${value}`)}">${template}</v-chip>` : template
    }

    isMagicChips(options, isTag, key, value, template, translationKey): string {
        let html = ''
        if (value) {
            let items = value
            if (!Array.isArray(value)) {
                items = value.split(',')
            }
            if (isTag) {
                items.forEach((item) => {
                    const color = options.find(option => option.title === item)?.color || 'grey'
                    html += `<v-chip variant="${this.$config.public.chips_variant || 'tonal'}" size="small" color="${color}" class="ma-1">${template}</v-chip>`
                })
            }
            else {
                html = items.join(', ')
            }
        }
        html = isTag ? html : `<ul>${html}</ul>`
        return html
    }

    isMultipleChips(key, value, template, translationKey) {
        let html = ''
        let items = value
        if (value) {
            if (!Array.isArray(value)) {
                items = value.split(',')
            }
            items.forEach((item) => {
                html += `<v-chip size="small" class="mr-1" color="${this.$getColor(`${translationKey}.${key}.${item}`)}">${item}</v-chip>`
            })
        }
        return html
    }

    toTranslate(key: string, value, translationKey: string = null) {
        if (!value) {
            return ''
        }
        const transKeys = []
        if (translationKey) {
            transKeys.push(translationKey)
        }
        if (key) {
            transKeys.push(key)
        }
        const sanitizedValue= value.toString()
            .replace(/[^\w$]/g,'');

        transKeys.push(sanitizedValue)
        return this.$translate(transKeys.join('.'))
    }

    hasUrlProperty(key, value): string {
        if (!value?.t) {
            return ''
        }
        if (!value?.url) {
            console.warn(`Object ${key} has no url property !`, value)
            return value.t
        }
        const url = (new HelperService()).relativeUrl(value.url)
        return `<a href="${url}" @click="$router.push('${url}')"><span class="cursor-pointer text-info">${value.t}</span></a>`
        // TODO pourquoi utiliser text-info pour tout les liens ?
    }

    isUrl(key, value): string {
        return `<a href="${value}" target="_blank"><span class="cursor-pointer text-info">${value}</span></a>`
    }

    isDate(key, value): string {
        if (!value) {
            return ''
        }
        return this.$formatDate(value)
    }

    isDateRange(key, value) {
        if (!value || !Array.isArray(value) || value.length !== 2) {
            return '-'
        }

        const [start, end] = value
        return `${this.$formatDate(start)} - ${this.$formatDate(end)}`
    }

    isNumber(key, value): number | string {
        if (typeof value === 'number') {
            return Number(value)
        }
        return '-'
    }

    isNumericDate(key, value): string {
        if (!value) {
            return ''
        }
        return this.$formatDate(value, 'numeric')
    }

    isDateTime(key, value): string {
        if (!value) {
            return ''
        }
        return this.$formatDateTime(value)
    }

    isBold(key, value): string {
        return `<b>${value}</b>`
    }

    isBooleanChipsWithColors(options, key, value): string {
        const color = options.find(option => option.title === String(value))?.color || 'grey'
        return ` <v-chip color="${color}" size="small" variant="${this.$config?.public?.chips_variant || 'tonal'}">
                            ${value ? 'Oui' : 'Non'}
                        </v-chip>
                    `
    }

    isBooleanText(key, value): string {
        return `${value ? 'Oui' : 'Non'}`
    }

    isBoolean(key, value): string {
        return ` <v-chip color="${value ? 'success' : 'danger'}" size="small" variant="${this.$config?.public?.chips_variant || 'tonal'}">
                            ${value ? 'Oui' : 'Non'}
                        </v-chip>
                    `
    }

    clearTags(key, value): string {
        if (typeof value === 'string') {
            return this._escapeHtml(value)
        }
        return value
    }

    isCroppedField(key, value: string, item, length = 80): string {
        if (!value)
            value = '-'

        if (value?.length <= length) {
            return value
        }
        return `${value.substring(0, length)}…`
    }

    isCroppedWithTooltip(key, value, template, item, length = 80): string {
        if (!value)
            value = '-'

        if (value?.length <= length) {
            return template
        }
        value = (new HelperService()).addBrAndNbsp(this._escapeHtml(value))
        return `<div>${template}<v-tooltip activator="parent" location="bottom" max-width="400">${value}</v-tooltip></div>`
    }

    textLeft(key, value, template) {
        return `<div class="text-left cursor-pointer">${template}</div>`
    }

    _escapeHtml(value): string {
        const div = document.createElement('div')
        div.textContent = value
        return div.innerHTML
    }
}
